/* eslint-disable */

export interface SponsoredAccountTransitionEvent {
  pending?: SponsoredAccountTransitionEventPending | undefined;
  active?: SponsoredAccountTransitionEventActive | undefined;
  suspended?: SponsoredAccountTransitionEventSuspended | undefined;
  canceled?: SponsoredAccountTransitionEventCanceled | undefined;
  sponsored_account_token?: string;
  dependent_customer_token?: string;
  sponsor_customer_token?: string;
  occurred_at?: number;
  flow_token?: string;
  request_source?: SponsoredAccountTransitionEventRequestSource;
  sponsored_account_state_transition_token?: string;
}

export enum SponsoredAccountTransitionEventRequestSource {
  CARD_ONBOARDING = "CARD_ONBOARDING",
  P2P = "P2P",
  PAPERMONEY_DEPOSIT = "PAPERMONEY_DEPOSIT",
  DEBIT_CASH_IN = "DEBIT_CASH_IN",
  FAMILY_ACCOUNT_NULL_STATE = "FAMILY_ACCOUNT_NULL_STATE",
  INVITE_LINK = "INVITE_LINK",
  INVESTING = "INVESTING",
  CRYPTO = "CRYPTO",
  GIFT_CARD = "GIFT_CARD",
  IDENTITY_HUB = "IDENTITY_HUB",
}

export interface SponsoredAccountTransitionEventPending {
  reason?: SponsoredAccountTransitionEventPendingReason;
  /**
   * Marqeta's sharding infrastructure necessitates migrating the dependent customer to the
   * sponsor customer's shard if they began on different shards. If this occurs as part of the
   * issuer account linking process, clients of this event may need to perform additional
   * actions to put the dependent's account in a good state for card issuing.
   */
  issuer_shard_migrated?: boolean;
  /**
   * In the future, it is not always guaranteed that a dependent customer has an account or virtual
   * card. If this is the case, an account will be created when they attempt to link. Clients may also need
   * to perform additional actions to put the dependent's account in a good state for card issuing.
   */
  issuer_account_created?: boolean;
}

export enum SponsoredAccountTransitionEventPendingReason {
  /** DEPENDENT_REQUESTED - Dependent customer has request sponsorship authorization */
  DEPENDENT_REQUESTED = "DEPENDENT_REQUESTED",
  /** ISSUER_ACCOUNT_LINKS_REQUIRED - Marqueta account linking is pending */
  ISSUER_ACCOUNT_LINKS_REQUIRED = "ISSUER_ACCOUNT_LINKS_REQUIRED",
  /** ISSUER_ACCOUNT_LINKS_ESTABLISHED - Marqueta account linking is completed */
  ISSUER_ACCOUNT_LINKS_ESTABLISHED = "ISSUER_ACCOUNT_LINKS_ESTABLISHED",
  /** DEPENDENT_ORDERED_CARD - Dependent customer requested sponsorship authorization via cash card request */
  DEPENDENT_ORDERED_CARD = "DEPENDENT_ORDERED_CARD",
}

export interface SponsoredAccountTransitionEventActive {
  reason?: SponsoredAccountTransitionEventActiveReason;
}

export enum SponsoredAccountTransitionEventActiveReason {
  /** SPONSOR_APPROVED - Sponsorship request is approved */
  SPONSOR_APPROVED = "SPONSOR_APPROVED",
  /** @deprecated */
  SPONSOR_UNSUSPENDED = "SPONSOR_UNSUSPENDED",
  /** @deprecated */
  SPONSOR_IDV_REINSTATED = "SPONSOR_IDV_REINSTATED",
  /** SUPPORT_APPROVED - CCO approved sponsorship request */
  SUPPORT_APPROVED = "SUPPORT_APPROVED",
  /** SPONSORSHIP_REINSTATED - Sponsored account is unsuspended */
  SPONSORSHIP_REINSTATED = "SPONSORSHIP_REINSTATED",
  /** @deprecated */
  SPONSOR_UNDENYLISTED = "SPONSOR_UNDENYLISTED",
  /** @deprecated */
  SPONSOR_ISSUER_UNSUSPENDED = "SPONSOR_ISSUER_UNSUSPENDED",
  GRADUATION_PENDING = "GRADUATION_PENDING",
}

export interface SponsoredAccountTransitionEventSuspended {
  reason?: SponsoredAccountTransitionEventSuspendedReason;
}

export enum SponsoredAccountTransitionEventSuspendedReason {
  /** SPONSOR_IDV_REVOKED - IDV for sponsor customer account is revoked */
  SPONSOR_IDV_REVOKED = "SPONSOR_IDV_REVOKED",
  /** SPONSOR_SUSPENDED - Sponsor customer account is suspended */
  SPONSOR_SUSPENDED = "SPONSOR_SUSPENDED",
  /** SPONSOR_DENYLISTED - Sponsor customer account is denylisted */
  SPONSOR_DENYLISTED = "SPONSOR_DENYLISTED",
  /** SPONSOR_ISSUER_SUSPENDED - Sponsor marqueta state is suspended */
  SPONSOR_ISSUER_SUSPENDED = "SPONSOR_ISSUER_SUSPENDED",
  /** GRADUATION_PENDING -  */
  GRADUATION_PENDING = "GRADUATION_PENDING",
}

export interface SponsoredAccountTransitionEventCanceled {
  reason?: SponsoredAccountTransitionEventCanceledReason;
}

export enum SponsoredAccountTransitionEventCanceledReason {
  /** SPONSOR_DECLINED - Sponsor account cancelled because sponsor declined the sponsorship request */
  SPONSOR_DECLINED = "SPONSOR_DECLINED",
  /** SUPPORT_CANCELED - Sponsored account was cancelled by CCO */
  SUPPORT_CANCELED = "SUPPORT_CANCELED",
  /**
   * SPONSOR_DENYLISTED - The sponsor was denylisted, and thus the sponsored account was cancelled.
   *
   * @deprecated
   */
  SPONSOR_DENYLISTED = "SPONSOR_DENYLISTED",
  /** SPONSOR_ACCOUNT_CLOSED - Sponsor customer account was closed (i.e. lifecycle status is CLOSED) */
  SPONSOR_ACCOUNT_CLOSED = "SPONSOR_ACCOUNT_CLOSED",
  /** SPONSOR_INELIGIBLE - Sponsor is no longer eligible to */
  SPONSOR_INELIGIBLE = "SPONSOR_INELIGIBLE",
  /** SPONSORED_ELSEWHERE - Dependent is now sponsored by another sponsor/account */
  SPONSORED_ELSEWHERE = "SPONSORED_ELSEWHERE",
  /** ISSUER_ACCOUNT_LINKS_FAILED - Account links failed to be established via marqueta */
  ISSUER_ACCOUNT_LINKS_FAILED = "ISSUER_ACCOUNT_LINKS_FAILED",
  /** DEPENDENT_CANCELED_REQUEST - Dependent customer cancelled the sponsorship request */
  DEPENDENT_CANCELED_REQUEST = "DEPENDENT_CANCELED_REQUEST",
  /** REQUEST_EXPIRED - Sponsorship request expired after being pending for longer than 15 days */
  REQUEST_EXPIRED = "REQUEST_EXPIRED",
  /** GRADUATED - Dependent customer has turned 18+ and has IDV'ed by itself */
  GRADUATED = "GRADUATED",
  /** DEPENDENT_ACCOUNT_CLOSED - Dependent customer account was closed (i.e. lifecycle status is CLOSED) */
  DEPENDENT_ACCOUNT_CLOSED = "DEPENDENT_ACCOUNT_CLOSED",
  /** DEPENDENT_INELIGIBLE - Dependent became ineligible while waiting for sponsorship approval */
  DEPENDENT_INELIGIBLE = "DEPENDENT_INELIGIBLE",
}
